import "./TimelineRow.css";
import { useState } from "react";
import Criterias from "../../../data/Criterias";
const TimelineRow = ({ label, lines, duration, audioRef, currentTime, showCriteria = true }) => {

    const mergeCloseLines = (lines, threshold = 1) => {
        if (!lines?.length) return [];

        const sorted = [...lines].sort((a, b) => a.start - b.start);

        const merged = [{ ...sorted[0] }];

        for (let i = 1; i < sorted.length; i++) {
            const current = sorted[i];
            const last = merged[merged.length - 1];

            const gap = current.start - last.end;

            if (gap <= threshold) {
                // fusionner
                last.end = Math.max(last.end, current.end);

                last.criterias = [
                    ...(last.criterias || []),
                    ...(current.criterias || [])
                ].filter((v, idx, arr) => arr.indexOf(v) === idx);

            } else {
                merged.push({ ...current });
            }
        }

        return merged;
    };

    const jumpTo = (time) => {
        const audio = audioRef.current?.audio?.current;
        if (audio) {
            audio.currentTime = time;
            audio.play();
        }
    };
    const mergedLines = mergeCloseLines(lines);
    const playhead = duration ? (currentTime / duration) * 100 : 0;
    return (
        <div className="timeline-row">
            <div className="timeline-label">{label}</div>

            <div className="timeline-track">

                {/* Playhead */}
                <div className="timeline-playhead" style={{ left: `${playhead}%` }} />

                {mergedLines.map((line, i) => {
                    const left = (line.start / duration) * 100;
                    const width = ((line.end - line.start) / duration) * 100;

                    return (
                        <div
                            key={i}
                            className={`speech-segment ${label.toLowerCase()}`}
                            style={{ left: `${left}%`, width: `${width}%` }}
                            onClick={() => jumpTo(line.start)}
                        >
                            {showCriteria && line.criterias?.map((c, j) => {
                                const criteria = Criterias.find(cr => cr.id === c);
                                if (criteria == null) return;
                                return (
                                    <div key={j} className="criteria-dot" title={criteria?.name || "Unknown"}
                                        style={{ left: `${(j) * 8}px`, backgroundColor: criteria.color }} />
                                );
                            })}
                        </div>
                    );
                })}

            </div>
        </div>
    );
};

export default TimelineRow;